// Arrays of 100 adjectives and 100 nouns to generate random names
export function getNames() {
  const adjectives = [
    "Abyssal",
    "Enigmatic",
    "Prismatic",
    "Ethereal",
    "Spectral",
    "Zenith",
    "Paradoxical",
    "Aurora",
    "Solaris",
    "Cryptic",
    "Astral",
    "Phantom",
    "Nebulous",
    "Galactic",
    "Celestial",
    "Infinite",
    "Radiant",
    "Luminous",
    "Nebula",
    "Quantum",
    "Eclipse",
    "Stellar",
    "Arcane",
    "Vortex",
    "Obsidian",
    "Glacial",
    "Serene",
    "Aether",
    "Nova",
    "Infinite",
    "Solar",
    "Void",
    "Mythic",
    "Inferno",
    "Temporal",
    "Lunar",
    "Chrono",
    "Astral",
    "Aurora",
    "Zenith",
    "Titan",
    "Frost",
    "Infernal",
    "Galactic",
    "Celestial",
    "Mystic",
    "Frozen",
    "Eternal",
    "Plasma",
    "Crystal",
    "Hypernova",
    "Omega",
    "Specter",
    "Chimeric",
    "Venomous",
    "Nocturnal",
    "Scarlet",
    "Cosmic",
    "Voidwalker",
    "Thorned",
    "Blazing",
    "Crimson",
    "Echoing",
    "Fiery",
    "Stormbound",
    "Thunderous",
    "Voidcaller",
    "Stormborn",
    "Spectral",
    "Darkwing",
    "Twilight",
    "Dawn",
    "Shattered",
    "Singularity",
    "Astronautic",
    "Nebular",
    "Radiant",
    "Shadow",
    "Oblivion",
    "Omni",
    "Frozen",
    "Vortex",
    "Primordial",
    "Echo",
    "Solar",
    "Nebula",
    "Electro",
    "Ephemeral",
    "Astrid",
    "Glacier",
    "Celestial",
    "Eclipse",
    "Wraith",
    "Inferno",
    "Vibrant",
    "Silent",
    "Phantom",
    "Wandering",
    "Voidstar",
    "Molten",
    "Stardust",
    "Specter",
  ];

  const nouns = [
    "Phoenix",
    "Chimera",
    "Raven",
    "Griffin",
    "Dragon",
    "Sphinx",
    "Leviathan",
    "Wyvern",
    "Cyclops",
    "Pegasus",
    "Kraken",
    "Basilisk",
    "Valkyrie",
    "Saber",
    "Obelisk",
    "Vortex",
    "Aether",
    "Seraphim",
    "Titan",
    "Specter",
    "Comet",
    "Nebula",
    "Voyager",
    "Eclipse",
    "Oracle",
    "Sundancer",
    "Warden",
    "Sentinel",
    "Mirage",
    "Specter",
    "Rune",
    "Orion",
    "Atlas",
    "Vanguard",
    "Scion",
    "Nomad",
    "Inferno",
    "Tempest",
    "Celestia",
    "Nova",
    "Astrid",
    "Eon",
    "Archon",
    "Fury",
    "Bane",
    "Wraith",
    "Sage",
    "Ember",
    "Rift",
    "Ascendant",
    "Stellar",
    "Nebula",
    "Etherea",
    "Solstice",
    "Frost",
    "Lich",
    "Abyss",
    "Chronos",
    "Shatter",
    "Specter",
    "Voidwalker",
    "Cryptid",
    "Rune",
    "Warden",
    "Stardust",
    "Oracle",
    "Shroud",
    "Cipher",
    "Shade",
    "Aegis",
    "Reaver",
    "Blaze",
    "Nimbus",
    "Arcana",
    "Nightfall",
    "Flare",
    "Spectra",
    "Dune",
    "Talon",
    "Storm",
    "Viper",
    "Ragnar",
    "Stalker",
    "Drake",
    "Cipher",
    "Nightshade",
    "Ghoul",
    "Infernal",
    "Goliath",
    "Zephyr",
    "Doombringer",
    "Prowler",
    "Thorn",
    "Specter",
    "Wisp",
    "Nighthawk",
    "Ash",
    "Serpent",
    "Frost",
    "Daemon",
    "Shade",
    "Ghost",
    "Viper",
  ];

  // Function to generate a random name
  const generateNFTName = () => {
    const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
    const noun = nouns[Math.floor(Math.random() * nouns.length)];
    return `${adjective} ${noun}`;
  };

  return {
    generateNFTName,
  };
}
// Example usage: Generating 5 random names
